import {definePreset} from "@primeuix/themes";
import Aura from "@primeuix/themes/aura";
import {colors} from "../../tailwind.config";
import {DividerDesignTokens} from "@primeuix/themes/types/divider";

export const MyPreset = definePreset(
  Aura,
  {
    primitive: {
      gradientBlue: {
        400: '#30A2FF',
        500: '#1488FC',
      },
      ...colors,
    },
    semantic: {
      primary: {
        50: "{blue.50}",
        100: "{blue.100}",
        200: "{blue.200}",
        300: "{blue.300}",
        400: "{blue.400}",
        500: "{blue.500}",
        600: "{blue.600}",
        700: "{blue.700}",
        800: "{blue.800}",
        900: "{blue.900}",
        950: "{blue.950}"
      },
      colorScheme: {
        light: {
          text: {
            color: "#000000"
          },
          surface: {
            0: "#ffffff",
            50: "{zinc.50}",
            100: "#FAF6F5",
            200: "{zinc.200}",
            300: "{zinc.300}",
            400: "{zinc.400}",
            500: "{zinc.500}",
            600: "{zinc.600}",
            700: "#434240",
            800: "{zinc.800}",
            900: "{zinc.900}",
            950: "{zinc.950}"
          }
        }
      }
    },
    components: {
      divider: {
        content: {
          background: "{surface.100}"
        }
      },
      dialog: {
        header: {
          padding: "{overlay.modal.padding} {overlay.modal.padding} 0.5rem {overlay.modal.padding}"
        }
      },
      accordion: {
        header: {
          color: "{text.color}",
          padding: "1.5rem 1.5rem 1.5rem 0"
        },
        content: {
          background: "transparent",
          color: "{text.color}",
          padding: "0 0 1rem 0"
        }
      },
      button: {
        root: {
          paddingX: "1.5rem",
          paddingY: "0.75rem",
          label: {
            fontWeight: "bold"
          },
          sm: {
            paddingX: "1rem",
            paddingY: "0.30rem"
          },
          borderRadius: "2rem"
        },
        colorScheme: {
          light: {
            root: {
              primary: {
                background: "{primary.500}",
                color: "{surface.0}",
              },
              secondary: {
                background: "{surface.950}",
                color: "{surface.0}",
                borderColor: "transparent",
                hoverBackground: "{surface.800}",
                hoverColor: "{surface.0}",
                activeBackground: "{surface.700}",
                activeColor: "{surface.0}",
                hoverBorderColor: "transparent"
              },
              info: {
                background: "{orange.500}",
                color: "{surface.0}",
                borderColor: "{orange.500}",
                hoverBackground: "{orange.600}",
                hoverColor: "{surface.0}",
                activeBackground: "{orange.600}",
                activeColor: "{surface.0}"
              },
              contrast: {

              }
            },
            outlined: {
              secondary: {
                borderColor: "{surface.950}",
                color: "{surface.950}"
              },
              info: {
                borderColor: "{orange.500}",
                color: "{surface.0}"
              },
              contrast: {
                borderColor: "{surface.950}",
                color: "{surface.950}"
              }

            },
            text: {
              info: {
                color: "{orange.500}"
              }
            }
          }
        }
      },
      tabs: {
        tab: {
          activeColor: "orange"
        },
        activeBar: {
          height: "0"
        }
      },
      card: {
        root: {
          background: "{surface.100}"
        }
      },
      togglebutton: {
        root: {
          padding: "0.2rem"
        },
        content: {
          borderRadius: "5px",
          padding: "0.1rem"
        },
        colorScheme: {
          light: {
            root: {
              borderColor: "{surface.200}",
              background: "white",
              checkedBackground: "white",
              checkedBorderColor: "{surface.200}",
              checkedColor: "white",
              hoverBackground: "{surface.200}",
              borderRadius: "1px"
            },
            content: {
              checkedBackground: "{surface.700}"
            }
          }
        }
      },
      rating: {
        icon: {
          color: "{surface.400}",
          activeColor: "{orange.400}",
          hoverColor: "{orange.300}",
          size: "1.75rem"
        }
      },
      drawer: {
        content: {
          padding: "1.75rem 1.25rem 2rem"
        }
      }
    }
  },
);

export const orangePanel = definePreset(MyPreset, {
  root: {
    background: "{orange.500}",
    borderColor: "transparent"
  },
  header: {
    borderWidth: "0"
  }
});

export const lighterOrangePanel = definePreset(MyPreset, {
  root: {
    background: "{orange.400}",
    borderColor: "transparent"
  },
  header: {
    borderWidth: "0"
  }
});

export const outlinedPanelButton = definePreset(MyPreset, {
  colorScheme: {
    light: {
      root: {
        secondary: {
          background: "{surface.100}",
          color: "{orange.400}",
          borderColor: "{orange.400}"
        }
      },
      outlined: {
        secondary: {
          borderColor: "{orange.400}",
          color: "{orange.400}"
        }
      }
    }
  }
});

export const whiteDividerDt: DividerDesignTokens = {
  content: {
    background: "white"
  }
};

export const whiteButtonDt = definePreset(MyPreset, {
  colorScheme: {
    light: {
      root: {
        primary: {
          background: "{surface.200}",
          color: "{surface.900}",
          borderColor: "{surface.300}",
          hoverBackground: "{surface.300}",
          hoverColor: "{surface.950}",
          hoverBorderColor: "{surface.300}"
        }
      }
    }
  }
});
